import React, { Component } from 'react'

import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,  MDBBreadcrumb, MDBBreadcrumbItem } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBJumbotron, MDBBox } from 'mdbreact';
import {
  MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem
} from "mdbreact";
import { MDBTable, MDBTableBody, MDBTableHead,  } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
//import Login from './Login';
import Axios from 'axios'
import { URL } from '../../api';
import logo from '../img/mmu.png'
import vdo from '../img/vdo1.mp4'
import FadeIn from 'react-fade-in';
import p1 from '../img/1656587759_2-illustration_png.png'
import p2 from '../img/1656587759_4-illustration_png.png'
import p3 from '../img/1656587761_12-illustration_png.png'
import Iframe from 'react-iframe'
import {isMobile, browserName, osName, OsTypes } from 'react-device-detect';
import kppg from '../img/kppg.gif'
import { HorizontalBar } from 'react-chartjs-2';
import ReactPlayer from 'react-player'
import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';
import kppgf from '../img/1920.jpg'
var xlsx = require("xlsx");


export default class welcome extends Component {


  constructor(props) {
    super(props);
    this.state = {
      
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,
      datastuKamphaengphet:[],
      team: '2565',
      sizem:'750',

      device:'',
      osName:'',
      browsername:'',
      datelogin:'',
      timelogin:'',
      
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onClick2 = this.onClick2.bind(this);
    this.readUploadFile = this.readUploadFile.bind(this);
    this.refreshPage = this.refreshPage.bind(this);

  }

  refreshPage() {
    window.location.reload(false);
  }


  componentDidMount() {

    if (localStorage.getItem('loginstatusdashboard') == null) {
        window.location.href = '/'  ;   
    } else {

    }

    if (isMobile) {
      const moment = require('moment');
      const  now = new Date();
      const formattedDate =moment(now).format('YYYY-MM-DD');
      const formattedtime =moment(now).format('HH:mm');
     // return <div> This content is available only on mobile</div>
      console.log('mobile')
      console.log(browserName)
      console.log(osName)
      console.log(formattedDate)

    
     this.setState({
      device: 'mobile',
      sizem:'250',
      browsername: browserName,
      datelogin : formattedDate,
      timelogin : formattedtime,
      osName : osName,
    });

    }else{
 
      console.log('browser')
      console.log(browserName)
      console.log(osName)
      const moment = require('moment');
      const  now = new Date();
      const formattedDate =moment(now).format('YYYY-MM-DD HH:mm:ss');
      const formattedtime =moment(now).format('HH:mm');

      console.log(formattedDate)

      this.setState({
        device: 'browser',
        sizem:'750',
        browsername: browserName,
        datelogin : formattedDate,
        timelogin : formattedtime,
        osName : osName,
      });
       
    }


  }

 onClick2() {
     console.log('dd')
          Axios.get('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json')
         .then((res) => {
      //  console.log(res.data)
       
        this.setState({ datastuKamphaengphet: res })
    })

  }


  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }


  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }




  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }

  readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);
         //   console.log(json);
            this.setState({ datastuKamphaengphet: json })

        };
        reader.readAsArrayBuffer(e.target.files[0]);
    }
}


  render() {
    const dUrl = "https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json";

  // console.log(dUrl);
   console.log(this.state.datastuKamphaengphet)
 //console.log('dd')
    const dataHorizontal = {
      labels: ['Red', 'Orange', 'Yellow', 'Green', 'Blue', 'Purple', 'Grey'],
      datasets: [
        {
          label: 'My First Dataset',
          data: [22, 33, 55, 12, 86, 23, 14],
          fill: false,
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(201, 203, 207, 0.2)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
          ],
          borderWidth: 1
        }
      ]
    }

    const sss = this.state.sizem

    return (

      <>
       
       <MDBRow >
          <MDBCol md="12">
            <div>
              {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
              {/* <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/> */}
              <FadeIn>
              <MDBJumbotron className="p-4" fluid >
                 
                {/* <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />   หน้าแรก
                </MDBTypography> */}
                   {/* <MDBTypography note noteColor='primary' noteTitle='ด้านนักศึกษา '> </MDBTypography> */}
                   {/* <MDBBreadcrumb>
                        <MDBBreadcrumbItem>จำนวนนักศึกษา</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>ระดับปริญญาตรี</MDBBreadcrumbItem>
                    </MDBBreadcrumb>

                    <div className='text-right'> <a href='/'><MDBBtn  color="blue-grey" size='sm'><MDBIcon icon="caret-left" /> กลับหน้าหลัก</MDBBtn></a><MDBBtn  color="mdb-color" size='sm' onClick={this.refreshPage}><MDBIcon icon="redo" /> refresh</MDBBtn></div>
         */}
                            {/* <br/> */}
                            {/* <p>ระบบโหลดข้อมูลจำนวนมาก กรุณารอสักครู่</p> */}

                            {/* <img src={kppg} className="rounded  mx-auto d-block w-10" alt="aligment" width={'100%'}/> */}
                             {/* <img src='https://www.canva.com/design/DAF0ZyR5zJM/TIPNTa1xKQ_xtSrKMyGVaw/watch?utm_content=DAF0ZyR5zJM&utm_campaign=designshare&utm_medium=link&utm_source=editor' className="rounded  mx-auto d-block w-10" alt="aligment" width={'100%'}/> */}

                            {/* <ReactPlayer
          className='react-player'
          url={vdo}
          width='100%'
          height='100%'
        /> */}
      
        {/* <ReactPlayer playing={true} url='https://www.canva.com/design/DAF0ZyR5zJM/TIPNTa1xKQ_xtSrKMyGVaw/watch?utm_content=DAF0ZyR5zJM&utm_campaign=designshare&utm_medium=link&utm_source=editor' /> */}
        {this.state.device === 'mobile' ? <>
        <img src={logo} className="rounded  mx-auto d-block w-10" alt="aligment" width={'40%'}/>
        <h3 className='text-center'>ยินดีต้อนรับ</h3>
       
        <img src={kppgf} className="rounded  mx-auto d-block w-10" alt="aligment" width={'100%'}/>
        <br/>
         <h5 className='text-center'>มหาวิทยาลัยราชภัฏกำแพงเพชร</h5>
        </>:<>
        <h4>แนะนำการพัฒนาและปรับปรุงระบบหลังจากการใช้งาน KPRU DASHBORAD  คลิก <MDBIcon icon="angle-double-right" /> <a href='https://docs.google.com/forms/d/e/1FAIpQLSeMljR0SlRsuju9zZzSA1sSUrPslYLFv3WoaXbaCnKGlWI6nw/viewform' target='_bank'>  ข้อเสนอแนะการใช้งานระบบ</a></h4>
       
         <video loop  width={'100%'} autoPlay muted src={vdo} />
        </>}
       
      {/* <MDBCarousel
          activeItem={1}
          length={3}
          showControls={true}
          showIndicators={true}
          className="z-depth-1"
          interval="10000"
          arrows
          centerMode={false}
         
          containerClass="container-with-dots"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          pauseOnHover
          renderArrowsWhenDisabled={false}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
        >
          <MDBCarouselInner>
            <MDBCarouselItem itemId="1">
            <Iframe url="https://lookerstudio.google.com/embed/reporting/72cce2fe-0ac2-4dff-8a07-4e34f41198d4/page/7XfiD"
                                 width="100%"
                                 height={sss}
                                 id=""
                                 className=""
                                 display="block"
                                 position="relative"/>
            </MDBCarouselItem>
            <MDBCarouselItem itemId="2">
            <Iframe url="https://lookerstudio.google.com/embed/reporting/e4e218a6-7d50-4d5c-bd32-caa8975df0ea/page/DPufD"
                                 width="100%"
                                 height={sss}
                                 id=""
                                 className=""
                                 display="block"
                                 position="relative"/>
            </MDBCarouselItem>
            <MDBCarouselItem itemId="3">
            <Iframe url="https://lookerstudio.google.com/embed/reporting/361680ce-5572-4a3a-b4bd-a780a20e0fd2/page/XxIgD"
                                 width="100%"
                                 height={sss}
                                 id=""
                                 className=""
                                 display="block"
                                 position="relative"/>
            </MDBCarouselItem>
          </MDBCarouselInner>
        </MDBCarousel> */}

                           
   
             
              </MDBJumbotron>

       

              </FadeIn>
            </div>
          </MDBCol>
        </MDBRow>

      </>


    )
  }
}
